import { createSelector } from "reselect";
import { RootState } from "../common/reducer";

type Id = string | number;

export const selectSupportState = (rootState: RootState) => (rootState as any).support;

export const messagesEntryByChatIdSelector = (chatId: Id | null) =>
  createSelector([selectSupportState], (state: any) => {
    if (!state || chatId == null) return undefined;
    return state.messagesByChatId?.[String(chatId)];
  });

export const cachedUserByIdSelector = (userId: Id | null) =>
  createSelector([selectSupportState], (state: any) => {
    if (!state || userId == null) return undefined;
    return state.usersById?.[String(userId)];
  });
